import React from 'react';
import qualification_item_style1_2_img from '../images/qualification-item-style1-2-img.jpg'
import qualification_item_style1_1_img from '../images/qualification-item-style1-1-img.jpg'
import qualification_item_style2_2_img from '../images/qualification-item-style2-2-img.jpg'
import qualification_item_style2_1_img from '../images/qualification-item-style2-1-img.jpg'
import './Qualification.css'
import GroupTitle, {GroupTitileOrange, GroupTitleBackground, GroupTitleText} from "./GroupTitle";
import PictureShow from "../pictureShow/PictureShow";
import {PSIPictureItem} from "../pictureShow/PictureShowItem";

export default function Qualification() {
    return (
        <div className='qualification'>
            <GroupTitle>
                <GroupTitleBackground>Qualification</GroupTitleBackground>
                <GroupTitleText>
                    <span>企业</span>
                    <GroupTitileOrange>资质</GroupTitileOrange>
                </GroupTitleText>
            </GroupTitle>
            <PictureShow className="qualification-picture-show">
                <PSIPictureItem src={qualification_item_style2_1_img}/>
                <PSIPictureItem src={qualification_item_style2_2_img}/>
                <PSIPictureItem src={qualification_item_style1_1_img}>国家高新技术企业认定</PSIPictureItem>
                <PSIPictureItem src={qualification_item_style1_2_img}>中关村高新技术企业</PSIPictureItem>
            </PictureShow>
        </div>
    )
}